import { useGetQueryHeroBannerMesh } from 'domains/merchandising/api/hero-banners/getContentHeroBannerMesh.hooks'
import { useGetQueryDepartmentName } from 'domains/merchandising/api/hero-banners/fetchDepartmentNameMesh.hooks'
import { useGetQueryProductName } from 'domains/merchandising/api/hero-banners/fetchProductNameMesh.hooks'
import { useRetailerId } from 'utils/routing/params.hooks'
import { PlacementDestinationTypeEnum } from 'domains/merchandising/api'

export const useQueryHeroBannerMesh = ({ id }) => {
  const retailerId = useRetailerId()
  const getQueryHero = useGetQueryHeroBannerMesh({
    placementId: id,
    retailerId,
  })
  const getQueryDeparment = useGetQueryDepartmentName({
    departmentId: getQueryHero.apiResult?.destination.target,
  })
  const getQueryProduct = useGetQueryProductName({
    productId: getQueryHero.apiResult?.destination.target,
  })

  if (getQueryHero.apiResult?.destination.type === PlacementDestinationTypeEnum.Department) {
    getQueryHero.apiResult.destination.displayValue = getQueryDeparment.apiResult
  } else if (getQueryHero.apiResult?.destination.type === PlacementDestinationTypeEnum.Product) {
    getQueryHero.apiResult.destination.displayValue = getQueryProduct.apiResult
  }

  return {
    apiResult: getQueryHero.apiResult,
    apiSuccess:
      getQueryHero.apiSuccess && getQueryDeparment.apiSuccess && getQueryDeparment.apiSuccess,
    apiLoading:
      getQueryHero.apiLoading || getQueryDeparment.apiLoading || getQueryDeparment.apiLoading,
    apiError: getQueryHero.apiError || getQueryDeparment.apiError || getQueryDeparment.apiError,
  }
}

export type HeroListBannerBehaviour = ReturnType<typeof useGetQueryHeroBannerMesh>
